import React from 'react';
import PropTypes from "prop-types";

import withLogFeatureUsage from 'react/containers/AnalyticContainer';
import Button from 'react/views/generic/Button';

const FindIt = ({catalogLink, featureType, srcId, destId}) => {
	const findItText = "Find it";
	let Comp = withLogFeatureUsage(Button, featureType, srcId, destId);

	if (catalogLink) {
		return <Comp href={catalogLink.href} target={catalogLink.target} small rel="noreferrer noopener">{findItText}</Comp>
	} else {
		return null;
	}
}

FindIt.propTypes = {
    catalogLink: PropTypes.object,
    featureType: PropTypes.object,
    srcId: PropTypes.string,
    destId: PropTypes.string
};

export default FindIt;



// WEBPACK FOOTER //
// ./src/react/views/generic/FindIt.jsx